import { cva } from 'class-variance-authority';

export const defaultHeadingCellClassName = 'truncate px-3 py-3.5 text-left text-sm font-normal text-info-500';

export const sortIconClasses = cva(['h-4', 'w-4', 'flex-none', 'rounded'], {
  variants: {
    isSorted: {
      true: 'text-info-900 bg-info-200',
      false: 'text-info-400 opacity-50',
    },
  },
});
